import { GetStaticProps, NextPage } from 'next'
import { Layout } from '../../../components/layout/layout'
import { REVALIDATION_FREQUENCY } from '../../../constants/revalidation'
import { GlobalProps, withLayoutProps } from '../../../globals/layout'
import { NewsLanding } from '../../../templates/newsLanding'
import { NewsLandingQuery, NewsLandingQueryDocument, NewsLandingQueryVariables } from '@gql'
import { pageQuery } from '../../../utils/pageQuery'

export type NewsLandingPageProps = GlobalProps & {
  data: NewsLandingQuery
}

const NewsLandingPage: NextPage<NewsLandingPageProps> = ({ data, ...layoutProps }) => {
  return (
    <Layout { ...layoutProps }>
      <NewsLanding { ...data } />
    </Layout>
  )
}

export default NewsLandingPage

export const getStaticProps: GetStaticProps = async (context) => {
  const { data } = await pageQuery<NewsLandingQuery, NewsLandingQueryVariables>({
    query: NewsLandingQueryDocument,
  }, context)

  return withLayoutProps({
    path: '/community/news',
  }, data.entry ? {
    props: { data },
    revalidate: REVALIDATION_FREQUENCY,
  } : {
    notFound: true,
  })
}
